import { compose, createStore, applyMiddleware } from "redux";

import { loadState, saveState } from "./localStorage";

import { thunk as thunkMiddleware } from "redux-thunk";
import appReducer from "./Redux/index";
const persistedState = loadState();

const enhancers = [];

const middleware = [thunkMiddleware];

export const store = createStore(
  appReducer,
  persistedState,
  compose(applyMiddleware(...middleware), ...enhancers)
);
   /* istanbul ignore next */
store.subscribe(() => {
  saveState({
    user: store.getState().user,
    userDetail: store.getState().userDetail,
  });
});
